'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EventVideo = function EventVideo(_ref) {
  var html = _ref.html;

  return _react2.default.createElement('div', { className: 'EventVideo', dangerouslySetInnerHTML: { __html: html } });
};

EventVideo.propTypes = {
  /**
   * The HTML code to display the video.
   */
  html: _propTypes2.default.string.isRequired
};

exports.default = EventVideo;


//////////////////
// WEBPACK FOOTER
// ./~/caligram-react/dist/components/EventVideo.js
// module id = 275
// module chunks = 0